"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkflowGroupPermissions = void 0;
const react_1 = require("react");
const user_ui_1 = require("@sierralabs/user-ui");
const useTaskWorkflow_1 = require("../tasks/hooks/useTaskWorkflow");
const useStateNodeByStatus_1 = require("./useStateNodeByStatus");
function useWorkflowGroupPermissions(task) {
    const { user } = (0, user_ui_1.useUserContext)();
    const workflow = (0, useTaskWorkflow_1.useTaskWorkflow)(task);
    const stateNode = (0, useStateNodeByStatus_1.useStateNodeByStatus)(task === null || task === void 0 ? void 0 : task.status, workflow);
    const permissions = (0, react_1.useMemo)(() => {
        var _a;
        return ((_a = stateNode === null || stateNode === void 0 ? void 0 : stateNode.meta) === null || _a === void 0 ? void 0 : _a.groupPermissions) || [];
    }, [stateNode]);
    const hasGroupPermissions = (0, react_1.useMemo)(() => {
        // skip check if there were no configured permissions
        return (permissions.length === 0 ||
            ((user === null || user === void 0 ? void 0 : user.groups) || []).some(group => permissions.includes(group.id)));
    }, [permissions, user]);
    return { permissions, hasGroupPermissions };
}
exports.useWorkflowGroupPermissions = useWorkflowGroupPermissions;
//# sourceMappingURL=useWorkflowGroupPermissions.js.map